import { useTranslation } from "react-i18next";
import { localDateTime } from "../../lib/datetime";
import { Info, RefreshCw, Search } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import { HoldRules } from "./HoldRules";

// شريط أدوات «الرواتب الموقوفة»: فحص فوري + تحديث القائمة + آخر فحص تلقائي.
export const HoldsToolbar = ({ lastScan, rules, busy, onScan, onReload }) => {
  const { t } = useTranslation();
  return (
    <div className="grid gap-4">
      <div className="flex flex-wrap items-center justify-between gap-3 rounded-3xl bg-[#0f2318] p-4 text-white">
        <div className="flex items-center gap-2 text-xs">
          <Info className="h-4 w-4 text-amber-300" />
          <div>
            <p className="font-bold">
              {t("holds.lastScan")}: <span className="font-mono">{lastScan ? localDateTime(lastScan) : "—"}</span>
            </p>
            <p className="text-white/60">{t("holds.autoNote")}</p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          <NeuButton className="bg-amber-600 px-4 py-2 text-white hover:bg-amber-700"
                     data-testid="holds-reload" disabled={busy} onClick={onReload}>
            <RefreshCw className="inline h-4 w-4" /> {t("holds.reload")}
          </NeuButton>
          <NeuButton className="bg-red-600 px-4 py-2 text-white hover:bg-red-700"
                     data-testid="holds-scan" disabled={busy} onClick={onScan}>
            <Search className="inline h-4 w-4" /> {t("holds.scanNow")}
          </NeuButton>
        </div>
      </div>
      <HoldRules rules={rules} />
    </div>
  );
};
